
    import I18n from '@canvas/i18n/i18nObj';
    
      import 'translations/lib.text_helper';
      import 'translations/_core';
    
    import 'translations/_core_en';

    export default I18n.scoped('lib.text_helper');
  